import momentJalaali from "moment-jalali";
import { Fragment, useEffect, useRef, useState } from 'react';
import { Button, Col, Modal, Row, Table } from 'react-bootstrap';
import { useDispatch, useSelector } from "react-redux";
import { getUserList, setReferDocPop } from "../store/api/Users";
import { referDocument } from '../store/api/Users';
import Loader from 'react-loader-spinner';
import { DashCircle, Reply, ReplyFill, Search } from 'react-bootstrap-icons';
import DatePicker from 'react-datepicker2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faReply, faTimes } from '@fortawesome/free-solid-svg-icons';
const ModalReferDocument = () => {
    const referData = useRef({});
    const searchData = useRef({});
    const selectedIDs = useRef([]);
    const dispatch = useDispatch();
    const [err, setError] = useState({});
    const [pending, setPending] = useState(false);
    const userList = useSelector(state => state.UserReducer.userList);
    const popup = useSelector(state => state.popup.referDocumentPop);
    const { documentHardCode, documentID, show } = popup;
    const close = () => {
        selectedIDs.current = [];
        setError({});
        referData.current.DeadlineDate = null;
        referData.current.DisplayDate = null;
        dispatch(setReferDocPop({ show: false }));
    };
    const setSelectedIDs = (add, id) => {
        if (add) {
            selectedIDs.current.push(id);
        }
        else {
            let indx = selectedIDs.current.indexOf(id);
            selectedIDs.current.splice(indx, 1);
        }
    }
    const search = () => {
        dispatch(getUserList(searchData.current.Name));
    }
    const referDoc = () => {
        setError({
            IDs: !selectedIDs.current || selectedIDs.current.length === 0 ? 'N' : null,
            Deadline: !referData.current.DeadlineDate ? 'N' : null,
            Display: !referData.current.DisplayDate ? 'N' : null,
            Priority: !referData.current.Priority || referData.current.Priority === '' ? "N" : null,
            ReferDescription: (!referData.current.ReferDescription || referData.current.ReferDescription === '') ? "N" : null
        });
        if (!selectedIDs.current || selectedIDs.current.length === 0 || !referData.current.DeadlineDate || !referData.current.DisplayDate ||
            !referData.current.Priority || referData.current.Priority === '' ||
            !referData.current.ReferDescription || referData.current.ReferDescription === '') {
            return;
        }
        setPending(true);
        referData.current.DocumentGroupHardCode = documentHardCode;
        referData.current.DocumentHardCode = documentHardCode;
        referData.current.DocumentID = documentID;
        referData.current.UserIDs = selectedIDs.current;
        const onSuccess = () => {
            close();
            setPending(false);
            dispatch(setReferDocPop({ show: false }));
        }
        dispatch(referDocument(referData.current, onSuccess));
    }
    return (
        <Modal show={show === true} style={{ direction: "rtl" }} onHide={() => { }}>
            <Modal.Header className='headerStyle'>
                <span>
                    <FontAwesomeIcon icon={faReply} size='lg' />&nbsp;
                    ارجاع به کارتابل کاربر
                </span>
                <FontAwesomeIcon icon={faTimes} size='lg' onClick={close} />
            </Modal.Header>
            <Modal.Body className='bodyStyle' style={{ paddingTop: "2px" }}>
                <Row>
                    <Col md={6} className="form-group">
                        <DatePicker placeholder="تاریخ نمایش" isGregorian={false} timePicker={true} className="form-control" min={momentJalaali()}
                            onChange={value => referData.current.DisplayDate = value.local("en").format("YYYY/MM/DD HH:mm")} inputJalaaliFormat="jYYYY/jMM/jDD HH:mm" />
                        {err.Display && <small className='errors' style={{ fontSize: "9px" }}>تاریخ نمایش الزامی است</small>}
                    </Col>
                    <Col md={6} className="form-group">
                        <DatePicker placeholder="تاریخ سررسید" isGregorian={false} timePicker={true} className="form-control" min={momentJalaali()}
                            onChange={value => referData.current.DeadlineDate = value.local("en").format("YYYY/MM/DD HH:mm")} inputJalaaliFormat="jYYYY/jMM/jDD HH:mm" />
                        {err.Deadline && <small className='errors' style={{ fontSize: "9px" }}>تاریخ سررسید الزامی است</small>}
                    </Col>
                    <Col md={6} className='form-group'>
                        <select className="form-control" onChange={e => referData.current.Priority = e.target.value}>
                            <option value=''>انتخاب اولویت</option>
                            <option value={3}>پایین</option>
                            <option value={2}>معمولی</option>
                            <option value={1}>بالا</option>
                        </select>
                        {err.Priority && <small className='errors' style={{ fontSize: "9px" }}>انتخاب اولویت الزامی است</small>}
                    </Col>
                    <Col md={6} className='form-group'>
                        <input type="text" className='form-control' placeholder="َشرح ارجاع" onChange={e => referData.current.ReferDescription = e.target.value} />
                        {err.ReferDescription && <small className='errors' style={{ fontSize: "9px" }}>شرح ارجاع الزامی است</small>}
                    </Col>
                </Row>
                <hr style={{ marginTop: "10px", marginBottom: "5px", color: "blue", height: "2px" }} />
                <Col md={6} className="form-group mt-1">
                    <input type="text" className="form-control tableRowInput" placeholder="نام کاربر" onChange={e => searchData.current.Name = e.target.value} />
                    <Button className="btn-input-tiny" style={{ top: 1, left: 2 }} onClick={search}><Search size={19} /></Button>
                </Col>
                {userList &&
                    <div className='scThin form-control' style={{ maxHeight: "150px", overflowX: "hidden", overflowY: "scroll", border: "1px solid gray", marginTop: "2px", padding: "0" }}>
                        <Table style={{ margin: 0 }}>
                            <tbody>
                                {Array.isArray(userList) && userList.map((item, i) => {
                                    return (
                                        <tr key={i} style={{ borderTop: "0.5px solid gray" }}>
                                            <td style={{ width: "10px" }}><input type="checkbox" className="form-check-input" onChange={(e) => setSelectedIDs(e.target.checked, item.ID)} /></td>
                                            <td>{item.Name}</td>
                                        </tr>)
                                }
                                )}
                            </tbody>
                        </Table>

                    </div>
                }
                {err.IDs && <small className='errors' style={{ fontSize: "9px" }}>انتخاب حداقل یک کاربر الزامی است</small>}

                <div className='mt-1'>
                    {pending && <Fragment><Loader type="BallTriangle" color="#bb1370" height={15} width={15} /><span>منتظر بمانید</span></Fragment>}
                    {!pending && <Button className='group-Btn' variant='info' onClick={referDoc}><ReplyFill size={16} />&nbsp; ارجاع به کاربر</Button>}
                    <Button variant='danger' className='group-Btn' onClick={close}><DashCircle size={16} />&nbsp; انصراف</Button>
                </div>
            </Modal.Body>
        </Modal>
    )
}
export default ModalReferDocument;